module.exports = __webpack_public_path__ + "img/fla.dc57133b.png";